module.exports = __webpack_public_path__ + "static/media/pdi-image-09.42bcddb7.svg";